import { filter } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { getConnectedUserJwt } from "src/core-logic/domain/admin/admin.helpers";
import { toAgencyUserForListing } from "src/core-logic/domain/agencies/agencies.helpers";
import { createUserOnAgencySlice } from "src/core-logic/domain/agencies/create-user-on-agency/createUserOnAgency.slice";
import { catchEpicError } from "src/core-logic/storeConfig/catchEpicError";
import type {
  ActionOfSlice,
  AppEpic,
} from "src/core-logic/storeConfig/redux.helpers";

export type CreateUserOnAgencyAction = ActionOfSlice<
  typeof createUserOnAgencySlice
>;

type CreateUserOnAgencyEpic = AppEpic<
  CreateUserOnAgencyAction | { type: "do-nothing" }
>;

const createUserOnAgencyEpic: CreateUserOnAgencyEpic = (
  action$,
  state$,
  { agencyGateway },
) =>
  action$.pipe(
    filter(createUserOnAgencySlice.actions.createUserOnAgencyRequested.match),
    switchMap((action) =>
      agencyGateway
        .createUserForAgency$(action.payload, getConnectedUserJwt(state$.value))
        .pipe(
          map((user) =>
            createUserOnAgencySlice.actions.createUserOnAgencySucceeded({
              icUser: toAgencyUserForListing(user),
              agencyId: action.payload.agencyId,
              feedbackTopic: action.payload.feedbackTopic,
            }),
          ),
          catchEpicError((error) =>
            createUserOnAgencySlice.actions.createUserOnAgencyFailed({
              errorMessage: error.message,
              feedbackTopic: action.payload.feedbackTopic,
            }),
          ),
        ),
    ),
  );

export const createUserOnAgencyEpics = [createUserOnAgencyEpic];
